
const stagingSES = {
    AccessKey: 'AKIAX5KAPZIJOGU6EXVQ',
    SecretKey: '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',
    ToAddress: 'contact@csympl.com',
    FromAddress: 'request@csympl.com'
}
export default stagingSES;